import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_LAST_PROCESS_DATE_API } from "./constants";
import queryKeys from "./queryKeys";

const useGetLastProcessDate = (options?: UseQueryOptions) => {
  return useQuery<string, AxiosError>(
    [queryKeys.getLastProcessDate],
    () =>
      axios
        .get(`${getAppConfigSetting("apiUrl")}${GET_LAST_PROCESS_DATE_API}`, {
          withCredentials: true,
        })
        .then(res => res.data),
    {
      enabled: options?.enabled,
      onError: (res: AxiosError<any>) => {
        console.error(res);
      },
      onSuccess: options?.onSuccess,
    }
  );
};

export default useGetLastProcessDate;
